export function absencePeriodLimitError(startDate: string, endDate: string, maximumDays?: number | null): string | undefined {
  if (!maximumDays || !startDate || !endDate) return undefined;
  const start = Date.parse(`${startDate}T00:00:00Z`);
  const end = Date.parse(`${endDate}T00:00:00Z`);
  const days = (end - start) / 86_400_000 + 1;
  return days > maximumDays ? `한 번에 최대 ${maximumDays}일까지 신청할 수 있습니다. 주말을 포함해 기간을 줄여 주세요.` : undefined;
}
